/**
 * OPS-STAB-002 — maps granted modules to UI reduction (panels, queues, API aggregation).
 */
export function buildWorkspaceReduction(access) {
  const m = access?.modules ?? {};
  return {
    navigation: {
      opBillingCounter: !!m.OP_BILLING_COUNTER,
      patientJourney: !!m.PATIENT_JOURNEY,
      ipDischarge: !!m.IP_DISCHARGE,
      inpatient: !!m.INPATIENT || !!m.IP_DISCHARGE,
      shiftContinuity: !!m.SHIFT_CONTINUITY,
      operationalAlerts: !!m.OPERATIONAL_ALERTS,
      refundReview: !!m.REFUND_REVIEW,
      financeAudit: !!m.FINANCE_AUDIT,
      labCounter: !!m.LAB_COUNTER,
      radiologyCounter: !!m.RADIOLOGY_COUNTER,
      pharmacyCounter: !!m.PHARMACY_COUNTER,
      patientToken: !!m.PATIENT_TOKEN,
      doctorConsultation: !!m.DOCTOR_CONSULTATION,
    },
    consultation: {
      showLabRecommendations: !!m.DOCTOR_CONSULTATION,
      showRadiologyRecommendations: !!m.DOCTOR_CONSULTATION,
      showProcedurePlaceholder: !!m.DOCTOR_CONSULTATION,
      showMedicinePlaceholder: !!m.DOCTOR_CONSULTATION,
      /** Hide legacy visit investigation POST when clinical recommendation flow is granted */
      hideLegacyInvestigations: !!m.DOCTOR_CONSULTATION,
    },
    billingWorkspace: {
      // Counter operational actions (payment/discount) — not Billing Operations module.
      // Pharmacy / reception cashiers hold PHARMACY_COUNTER or BILLINGPAYMENT without OP_BILLING_COUNTER.
      showPaymentDock:
        !!m.OP_BILLING_COUNTER ||
        !!m.PHARMACY_COUNTER ||
        !!access?.hasActionPermission?.('FONE:BILLINGPAYMENT'),
      showDiscountPanel:
        !!m.OP_BILLING_COUNTER ||
        !!m.PHARMACY_COUNTER ||
        !!access?.hasActionPermission?.('FONE:BILLINGPAYMENT'),
      showRefundPanel: !!m.OP_BILLING_COUNTER,
      showPackagePanel: !!m.OP_BILLING_COUNTER,
      showClinicalOrders: !!m.OP_BILLING_COUNTER,
      showShiftStrip:
        !!m.OP_BILLING_COUNTER ||
        !!m.PHARMACY_COUNTER ||
        !!m.SHIFT_CONTINUITY ||
        !!access?.hasActionPermission?.('FONE:SHIFTOPEN'),
      showRefundReviewRail: !!m.REFUND_REVIEW,
      showSupervisorApprovals: !!m.REFUND_REVIEW || !!m.FINANCE_AUDIT,
    },
    desks: {
      loadPatientJourney: !!m.PATIENT_JOURNEY,
      loadIpDischarge: !!m.IP_DISCHARGE,
      loadInpatient: !!m.INPATIENT || !!m.IP_DISCHARGE,
      loadShiftContinuity: !!m.SHIFT_CONTINUITY,
      loadOperationalAlerts: !!m.OPERATIONAL_ALERTS,
    },
    aggregations: {
      labQueue: !!m.LAB_COUNTER || !!m.PATIENT_JOURNEY,
      radiologyQueue: !!m.RADIOLOGY_COUNTER || !!m.PATIENT_JOURNEY,
      pharmacyQueue: !!m.PHARMACY_COUNTER || !!m.PATIENT_JOURNEY,
      dischargeQueue: !!m.IP_DISCHARGE,
      alertDesk: !!m.OPERATIONAL_ALERTS,
    },
    print: {
      invoice: !!m.OP_BILLING_COUNTER,
      receipt: !!m.OP_BILLING_COUNTER,
      labReport: !!m.LAB_COUNTER,
      radiologyReport: !!m.RADIOLOGY_COUNTER,
      pharmacyIssue: !!m.PHARMACY_COUNTER,
    },
  };
}
